'use strict';

bbw.service.FeedbackUnreadCountSvc = Class({

    $inject: ['rpcClient', '$rootScope', '$timeout', '$q'],

    FEEDBACK_UNREAD_COUNT_UPDATED_EVENT: 'feedback-unread-count-updated-event',
    UPDATE_INTERVAL: 30000,

    _rpcClient: undefined,
    _count: undefined,
    _timeout: undefined,

    construct: function(rpcClient, $rootScope, $timeout, $q) {
        this._rpcClient = rpcClient;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this._init();
    },

    subscribe: function(cb, scope, noImmediate) {
        if (!scope) {
            scope = this.$rootScope;
        }
        var destroyed = false;
        scope.$on('$destroy', function() {
            destroyed = true;
        });
        scope.$on(this.FEEDBACK_UNREAD_COUNT_UPDATED_EVENT, function(_, data) {
            if (!destroyed) {
                cb(data.count);
            }
        });
        if (!noImmediate) {
            angular.isDefined(this._count) && cb(this._count);
        }
    },

    _emit: function() {
        angular.isDefined(this._count) && this.$rootScope.$broadcast(this.FEEDBACK_UNREAD_COUNT_UPDATED_EVENT, {count: this._count});
    },

    _init: function() {
        this._update().then(this._listen.bind(this));
    },

    _update: function() {
        if (bbw.userIsLocked) {
            this._count = 0;
            return this.$q.when();
        }
        return this._rpcClient.get('feedback/get-unread-count').execute().then(function(response) {
            if (response.count > 0) {
                this.$rootScope.$broadcast(bbw.event.NEW_FEEDBACK, {count: response.count});
            }
            this._count = response.count;
            this._emit();
            this._setTimeout();
        }.bind(this));
    },

    _setTimeout: function(interval) {
        if (angular.isDefined(this._timeout)) {
            clearTimeout(this._timeout);
        }
        this._timeout = setTimeout(this._update.bind(this), interval || this.UPDATE_INTERVAL);
    },

    _listen: function() {
        this.$rootScope.$on('bbw-update-feedback-unread-count', function() {
            this._setTimeout(500);
        }.bind(this));
    }

});